module.exports = __webpack_public_path__ + "img/half.8f309b94.png";